export default [
  {
    id: 'c49136dc-32cb-44d5-8261-59ba260fd0c0',
    path: 'data-metrics',
    name: 'data-metrics',
    meta: { title: '数据指标' },
    children: [
      {
        id: 'b2ef04bf-a28c-4314-ac0b-8b05cf8b693b',
        path: 'metrics-management',
        name: 'metrics-management',
        component: () => {
          return import('../views/data-metrics/MetricsManagement')
        },
        meta: {
          title: '指标管理',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            copy: {
              id: 3,
              name: 'copy',
              desc: '复制',
              access: true,
            },
            metricsData: {
              id: 4,
              name: 'metricsData',
              desc: '指标数据',
              access: true,
            },
            publish: {
              id: 5,
              name: 'publish',
              desc: '发布',
              access: true,
            },
          },
        },
      },
      {
        id: 'c0f5a9a9-1fbc-48c8-a9ec-45ee6bd58457',
        path: 'atomic-indicators',
        name: 'atomic-indicators',
        component: () => {
          return import('../views/data-metrics/AtomicIndicators')
        },
        meta: {
          title: '原子指标',
          tabnab: false,
          hidden: true,
          keepAlive: false,
          activeMenu: '/legacy-resource/data-metrics/metrics-management',
        },
      },
      {
        id: 'aeecea14-44b4-418e-b201-993f30e17575',
        path: 'derived-metrics',
        name: 'derived-metrics',
        component: () => {
          return import('../views/data-metrics/DerivedMetrics')
        },
        meta: {
          title: '派生指标',
          tabnab: false,
          hidden: true,
          keepAlive: false,
          activeMenu: '/legacy-resource/data-metrics/metrics-management',
        },
      },
      {
        id: '1a98c9e9-2da7-4cfc-a07b-42c74fd9ab8e',
        path: 'composite-metrics',
        name: 'composite-metrics',
        component: () => {
          return import('../views/data-metrics/CompositeMetrics')
        },
        meta: {
          title: '复合指标',
          tabnab: false,
          hidden: true,
          keepAlive: false,
          activeMenu: '/legacy-resource/data-metrics/metrics-management',
        },
      },
      {
        id: '31f39c03-4e2a-483d-bc28-49664e566770',
        path: 'metrics-data',
        name: 'metrics-data',
        component: () => {
          return import('../views/data-metrics/MetricsData')
        },
        meta: {
          title: '指标数据',
          tabnab: false,
          hidden: true,
          keepAlive: false,
          activeMenu: '/legacy-resource/data-metrics/metrics-management',
        },
      },
    ],
  },
]
